import {
  getAssetTypeIdFromAccountType,
  isIncomeStreamAssetTypeId,
  type AssetTypeId,
} from '@/features/guided-financial-planning/config';

/**
 * Resolve the asset type from a raw `accountType` string. Falls back to
 * `'other'` when the account type is unknown or is the special
 * `'existing-ltc-policy'` value (which isn't selectable here).
 */
export function getInitialAssetType(
  accountType: string | null | undefined,
): AssetTypeId | 'other' {
  const assetTypeId = getAssetTypeIdFromAccountType(accountType);
  if (assetTypeId && assetTypeId !== 'existing-ltc-policy') return assetTypeId;
  return 'other';
}

/**
 * For non-income-stream specific asset types, derive the yearly contribution
 * (display value) from the stored monthly amount. Returns `null` for "Other"
 * and income-stream types which don't surface a yearly contribution field.
 */
export function getInitialYearlyContribution(
  assetType: AssetTypeId | 'other',
  monthlyAmount: number | null | undefined,
): number | null {
  if (assetType !== 'other' && !isIncomeStreamAssetTypeId(assetType) && monthlyAmount) {
    return monthlyAmount * 12;
  }
  return null;
}
